import React from 'react';
import { SelectedOfferFees as ConnectedSelectedOfferFees } from 'containers/SelectedOfferFees/SelectedOfferFees';
import { IncludedFees } from 'components/IncludedFees/IncludedFees';

const SelectedOfferFees = () => (
  <ConnectedSelectedOfferFees render={fees => <IncludedFees fees={fees} />} />
);

export { SelectedOfferFees };
